/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityLookalikesResult } from './ControlEntityLookalikesResult';
import {
    ControlEntityLookalikesResultFromJSON,
    ControlEntityLookalikesResultFromJSONTyped,
    ControlEntityLookalikesResultToJSON,
} from './ControlEntityLookalikesResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityLookalikesResponse
 */
export interface ControlPaginatedEntityLookalikesResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityLookalikesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityLookalikesResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityLookalikesResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityLookalikesResult>}
     * @memberof ControlPaginatedEntityLookalikesResponse
     */
    results: Array<ControlEntityLookalikesResult>;
}

/**
 * Check if a given object implements the ControlPaginatedEntityLookalikesResponse interface.
 */
export function instanceOfControlPaginatedEntityLookalikesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedEntityLookalikesResponseFromJSON(json: any): ControlPaginatedEntityLookalikesResponse {
    return ControlPaginatedEntityLookalikesResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityLookalikesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityLookalikesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': ((json['results'] as Array<any>).map(ControlEntityLookalikesResultFromJSON)),
    };
}

export function ControlPaginatedEntityLookalikesResponseToJSON(value?: ControlPaginatedEntityLookalikesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlEntityLookalikesResultToJSON)),
    };
}

